import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RoleProtectedFieldProps {
  children: React.ReactNode;
  requiredRoles?: string[];
  requiredPermissions?: string[];
  requireAll?: boolean; // true: 需要所有权限/角色, false: 需要任一权限/角色
}

const RoleProtectedField: React.FC<RoleProtectedFieldProps> = ({
  children,
  requiredRoles = [],
  requiredPermissions = [],
  requireAll = false,
}) => {
  const { hasPermission, hasRole, hasAnyPermission, hasAnyRole } = useAuth();

  // 如果没有指定任何权限或角色要求，默认显示
  if (requiredPermissions.length === 0 && requiredRoles.length === 0) {
    return <>{children}</>;
  }

  // 检查权限
  let hasRequiredPermissions = true;
  if (requiredPermissions.length > 0) {
    if (requireAll) {
      hasRequiredPermissions = requiredPermissions.every(permission => hasPermission(permission));
    } else {
      hasRequiredPermissions = hasAnyPermission(requiredPermissions);
    }
  }

  // 检查角色
  let hasRequiredRoles = true;
  if (requiredRoles.length > 0) {
    if (requireAll) {
      hasRequiredRoles = requiredRoles.every(role => hasRole(role));
    } else {
      hasRequiredRoles = hasAnyRole(requiredRoles);
    }
  }

  // 综合权限和角色检查
  const hasAccess = hasRequiredPermissions && hasRequiredRoles;

  if (!hasAccess) {
    return null; // 不显示字段
  }

  return <>{children}</>;
};

export default RoleProtectedField;